/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { NoveltyCalcKeyFigureStatusRowDto } from './NoveltyCalcKeyFigureStatusRowDto';
import {
    NoveltyCalcKeyFigureStatusRowDtoFromJSON,
    NoveltyCalcKeyFigureStatusRowDtoFromJSONTyped,
    NoveltyCalcKeyFigureStatusRowDtoToJSON,
    NoveltyCalcKeyFigureStatusRowDtoToJSONTyped,
} from './NoveltyCalcKeyFigureStatusRowDto';

/**
 * 
 * @export
 * @interface NoveltyCalcResultsSummaryDto
 */
export interface NoveltyCalcResultsSummaryDto {
    /**
     * 
     * @type {NoveltyCalcKeyFigureStatusRowDto}
     * @memberof NoveltyCalcResultsSummaryDto
     */
    listPriceIndex: NoveltyCalcKeyFigureStatusRowDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureStatusRowDto}
     * @memberof NoveltyCalcResultsSummaryDto
     */
    listPriceFmcFactor: NoveltyCalcKeyFigureStatusRowDto;
    /**
     * 
     * @type {NoveltyCalcKeyFigureStatusRowDto}
     * @memberof NoveltyCalcResultsSummaryDto
     */
    retailMargin: NoveltyCalcKeyFigureStatusRowDto;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcResultsSummaryDto
     */
    target?: number;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcResultsSummaryDto
     */
    targetFmc?: number;
}

/**
 * Check if a given object implements the NoveltyCalcResultsSummaryDto interface.
 */
export function instanceOfNoveltyCalcResultsSummaryDto(value: object): value is NoveltyCalcResultsSummaryDto {
    if (!('listPriceIndex' in value) || value['listPriceIndex'] === undefined) return false;
    if (!('listPriceFmcFactor' in value) || value['listPriceFmcFactor'] === undefined) return false;
    if (!('retailMargin' in value) || value['retailMargin'] === undefined) return false;
    return true;
}

export function NoveltyCalcResultsSummaryDtoFromJSON(json: any): NoveltyCalcResultsSummaryDto {
    return NoveltyCalcResultsSummaryDtoFromJSONTyped(json, false);
}

export function NoveltyCalcResultsSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcResultsSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'listPriceIndex': NoveltyCalcKeyFigureStatusRowDtoFromJSON(json['listPriceIndex']),
        'listPriceFmcFactor': NoveltyCalcKeyFigureStatusRowDtoFromJSON(json['listPriceFmcFactor']),
        'retailMargin': NoveltyCalcKeyFigureStatusRowDtoFromJSON(json['retailMargin']),
        'target': json['target'] == null ? undefined : json['target'],
        'targetFmc': json['targetFmc'] == null ? undefined : json['targetFmc'],
    };
}

export function NoveltyCalcResultsSummaryDtoToJSON(json: any): NoveltyCalcResultsSummaryDto {
    return NoveltyCalcResultsSummaryDtoToJSONTyped(json, false);
}

export function NoveltyCalcResultsSummaryDtoToJSONTyped(value?: NoveltyCalcResultsSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'listPriceIndex': NoveltyCalcKeyFigureStatusRowDtoToJSON(value['listPriceIndex']),
        'listPriceFmcFactor': NoveltyCalcKeyFigureStatusRowDtoToJSON(value['listPriceFmcFactor']),
        'retailMargin': NoveltyCalcKeyFigureStatusRowDtoToJSON(value['retailMargin']),
        'target': value['target'],
        'targetFmc': value['targetFmc'],
    };
}

